export default __webpack_public_path__ + "static/media/pope_worldwide_es.ab77d965.svg";